// import main packages
import React, {useEffect, useRef, useState} from "react";
import {useRecoilState} from "recoil";
import {useTranslation} from "react-i18next";

// import packages
import {ObjectInspector, chromeLight} from 'react-inspector';

// import recoil state
import {testAppLog} from "../../../../../../recoil-store/recoil-state";

// import css files
import "./testAppLog.css";

// import material ui elements
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {CircularProgress, Dialog, DialogTitle} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";


function TestAppLog({setOpenTestAppLog, showTriggerRightArea, showRightArea, openRunningModal, handleTestAppCancel}) {
    const [testAppLogs, setTestAppLogs] = useRecoilState(testAppLog);
    const datae = useRef(testAppLogs);
    const [data, setData] = useState(datae.current);
    const {t} = useTranslation();
    const testAppLogContainer = useRef();

    // Set state on debugList changme
    useEffect(() => {
        if (Object.keys(testAppLogs).length > 0) {
            handleTestAppCancel(true)
        }
        setData(testAppLogs);
        datae.current = testAppLogs;
    }, [testAppLogs]);

    //close model
    function handleClose() {
        setOpenTestAppLog(false);
    }

    return (
        <Dialog
            id="trigger-app-log-dialog"
            open={true}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                id: "trigger-app-log-dialog"
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t("CONTENT.FLOW.TEST-APP-PREVIEW")}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close/>
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent style={{height: 600}}>
                <div
                    className={`trigger-data-container ${showTriggerRightArea ? "w-45" : showRightArea ? "" : "full"}`}
                    style={!openRunningModal ? {zIndex: 1} : {}} ref={testAppLogContainer}>
                    {Object.keys(data).length > 0 ? (
                        <div className="trigger-data">
                            <div className="trigger-message">
                                <CheckCircleIcon style={{color: "green"}}/>
                                <span>{t("CONTENT.FLOW.TRIGGER-RECEIVED")}</span>
                            </div>
                            <div className="trigger-data-inspector">
                                <span className="trigger-data-preview">{t("CONTENT.FLOW.TRIGGERED-DATA-PREVIEW")}</span>
                                <ObjectInspector data={data.data}
                                                 theme={{...chromeLight, ...({TREENODE_LINE_HEIGHT: 2})}}/>
                            </div>
                        </div>
                    ) : (
                        <div className="no-trigger-data">
                            <CircularProgress color="secondary"/>
                            <span className="text-progress">{t("CONTENT.FLOW.WAITING-FOR-TRIGGER")}</span>
                            <Button
                                onClick={() => handleTestAppCancel(false)}
                                className="cancel-button"
                            >
                                {t("CONTENT.FLOW.CANCEL")}
                            </Button>
                        </div>
                    )}
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "flex-end",
                    padding: "8px 24px 16px 24px",
                }}
            />
        </Dialog>
    )
}

export default TestAppLog;
